// extracted by mini-css-extract-plugin
export default {"container":"ClientKanban_container__DfkMZ","button":"ClientKanban_button__-+cxn"};